import { useLogGoodsAnalyticsEvent } from '../../../hooks/useLogGoodsAnalyticsEvent';
import { useGoodsBasic } from '../../../queries/useGoodsBasic';
import { isNil } from 'shared/src/utils';
import { useRetainedEffect } from 'shared/src/hooks/retainedState';

export const useLogDisplayBrandHome = () => {
  const logGoodsAnalytics = useLogGoodsAnalyticsEvent();
  const { data: goodsBasic } = useGoodsBasic();

  useRetainedEffect(
    'display-brand-home',
    () => {
      if (isNil(goodsBasic)) return false;
      if (isNil(goodsBasic.brand)) return false;

      const brand = goodsBasic.brand;
      logGoodsAnalytics({
        name: 'DISPLAY_BRAND_HOME',
        analytics: {
          GOODS_SNO: goodsBasic.sno.toString(),
          BRAND_SNO: brand.sno.toString(),
          BRAND_NAME: brand.name,
          MARKET_NAME: goodsBasic.market.name,
          MARKET_SNO: goodsBasic.market.sno.toString(),
          MARKET_TYPE: brand.brand_vertical_type.name,
        },
      });
    },
    [goodsBasic, logGoodsAnalytics],
  );
};